(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-cz-gallery-src]');
  if (!button) return;
  const gallery = button.closest('.cz-gallery');
  const image = gallery.querySelector('[data-native-image]');
  image.removeAttribute('srcset');
  image.src = button.dataset.czGallerySrc;
  image.alt = button.dataset.czGalleryAlt;
  gallery.querySelectorAll('[data-cz-gallery-src]').forEach(function(item) {
    item.setAttribute('aria-pressed', String(item === button));
  });
});

  } catch(e) { console.error(e); }
})();
})();
